import { render, staticRenderFns } from "./template-preview-card.vue?vue&type=template&id=3614ac05"
import script from "./template-preview-card.vue?vue&type=script&setup=true&lang=js"
export * from "./template-preview-card.vue?vue&type=script&setup=true&lang=js"
import style0 from "./template-preview-card.vue?vue&type=style&index=0&id=3614ac05&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports